import { render } from "./PersonalDataDeletion.vue?vue&type=template&id=280aed44"
import script from "./PersonalDataDeletion.vue?vue&type=script&lang=js"
export * from "./PersonalDataDeletion.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__